/**
 * BrillBuy Shop - Vue.js Entry Point
 *
 * Vue components are used for interactive elements within Blade templates.
 * Pages are server-rendered for SEO, with Vue adding interactivity.
 */

import Vue from 'vue';

// Import shop components
import AddToBasket from './components/AddToBasket.vue';
import BasketWidget from './components/BasketWidget.vue';
import BasketItems from './components/BasketItems.vue';

// Vue configuration
Vue.config.productionTip = false;

// Register components globally
Vue.component('add-to-basket', AddToBasket);
Vue.component('basket-widget', BasketWidget);
Vue.component('basket-items', BasketItems);

// Auto-mount Vue on elements with data-vue attribute
document.addEventListener('DOMContentLoaded', () => {
    // Find all elements that should be Vue roots
    const vueRoots = document.querySelectorAll('[data-vue-root]');

    vueRoots.forEach(el => {
        new Vue({
            el: el,
        });
    });

    // Also mount on #shop-app if it exists (main app container)
    const shopApp = document.getElementById('shop-app');
    if (shopApp) {
        new Vue({
            el: '#shop-app',
        });
    }

    console.log('BrillBuy shop initialized');
});
